import React from 'react';

import classes from './Confirm.css';
import Aux from '../../../../hoc/Auxiliary/Auxiliary';
import Backdrop from '../../Backdrop/Backdrop';
import Button from '../../Button/Button';

const confirm = (props) => {

  let transformedClicked = (ev) => {
    props.closeCard(ev);
    props.clicked(ev);
  }

  let transformNewLines = () => {
    if (props.confirmText.indexOf("\n") > -1) {
      return props.confirmText.split("\n").map(function(item, idx) {
          return (
              <div key={idx}> {item} </div>
           )
      })
    } else {
      return props.confirmText;
    }
  }

  let confirm = null;
  if (props.show) {
    confirm  = (
      <div
        className={classes.Confirm}
        style={{transform: props.show ? 'translateY(0)' : 'translateY(-100vh)',
                opacity: props.show ? '1' : '0'}}>
        <p className={classes.ConfirmText}>Вы уверены что вы хотите <strong>{transformNewLines()}</strong>?</p>

        <div className={classes.OptionHolder}>
          <Button
            btnType='Success'
            clicked={transformedClicked}
            extraClass={classes.ConfirmButton}>
          Да
          </Button>
          <Button
            btnType='Danger'
            clicked={props.closeCard}
            extraClass={classes.DeclineButton}>
          Нет
          </Button>
        </div>
      </div>
    )
  }


  return (
    <Aux>
      <Backdrop show={props.show} clicked={props.closeCard} />
      { confirm }
    </Aux>
  );
};

export default confirm;



// WEBPACK FOOTER //
// ./src/components/UI/ButtonIconConfirm/Confirm/Confirm.js